export const formButtonStyle = {
    width: "70%", marginTop: "15px" 
}